<template>
  <el-form>
    <el-form-item label="名称">
      <el-input v-model="form.name" placeholder="请输入名称"></el-input>
    </el-form-item>
    <el-form-item label="位置" prop="position">
      <el-select v-model="form.position" placeholder="位置" class="w-150" @change="formChange">
        <el-option v-for="item in positionList" :label="item.title" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="类型" prop="type">
      <el-select v-model="form.type" placeholder="类型" class="w-150" @change="formChange">
        <el-option v-for="item in componentList" :label="item.title" :value="item.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="表单" prop="model_id">
      <el-select v-model="form.model_id" placeholder="表单" class="w-150" @change="formChange">
        <el-option v-for="item in models" :label="item.title" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="排序" prop="sort">
      <el-input v-model="form.sort" type="number" placeholder="请输入排序"></el-input>
    </el-form-item>
    <el-form-item label="绑定权限规则">
      <el-input v-model.trim="form.rule_name" class="h-40 fl w-150 m-r-10" :disabled="true" placeholder="绑定权限规则"></el-input>
      <el-button size="small" class="fl" @click="openRule(form)">查找</el-button>
      <el-button size="small" class="fl m-l-5" @click="clearRule()">清空</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import mobileConfig from 'config/mobileConfig'
  export default {
    props: {
      form: {
        type: Object
      },
      models: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
      }
    },
    methods: {
      openRule(item) {
        this.$emit('openRule', item)
      },
      clearRule() {
        this.form.rule_name = ''
        this.form.rule_id = null
      },
      formChange() {
        this.$emit('formChange')
      }
    },
    mixins: [mobileConfig]
  }
</script>


// WEBPACK FOOTER //
// rightConfig.vue?9cd82aee